import React from 'react';
import {slugify} from 'utils';
import PropTypes from 'prop-types';
import PromotionFactory from 'factories/Promotion';
import style from './style.scss'; //NOSONAR

const ProductFlags = (props) => {

    const full = props.full || false;

    const getTags = () => {
        const item = props.item;
        if(!item) return [];
        let isOffer = false;

        const flags = [];
        const promotions = PromotionFactory.create(item);

        promotions.map(promotion => {
            if(!promotion.tcenco){
                isOffer = true;
            }
        } );

        if(isOffer){
            flags.push({
                titleFlag: 'Oferta',
                classFlag: 'oferta',
                tcenco: false
            });
        }

        return flags;
    }

    const getFlags = () => {
        const item = props.item;
        if(!item) return[];

        return item.clusterClass;
    }

    const {nutritionalTag, customTitle} = props;
    const tags = getTags();
    const flags = getFlags();
    const mappedFlags = flags ? flags.map((flag,i) => <span className={'product-flag ' + flag + (customTitle ? ' with-title' : '')} key={i} />) : '';
    let tcenco = false;
    const containTcenco = !!tags.filter(tag => tag.tcenco).length;

    return (
        <div className={'product-flags'}>
            {(!!customTitle && !nutritionalTag && !!mappedFlags.length) && <span className="product-flags-title">{customTitle}</span>}
            {nutritionalTag &&
                tags.map((tag,i) => {
                    if(tag.tcenco){
                        if(tcenco) return '';
                        tcenco = true;
                    }
                    return <span className={'product-flag  ' + slugify(tag.classFlag) + (tag.tcenco ? ' tcenco ' : '') + ((containTcenco && !tag.tcenco) ? ' not-tcenco' : '')} key={i}>
                        <span className={'product-flag-text' + ((tag.titleFlag.length > 4 && (tag.titleFlag.indexOf('x') !== -1)) ? ' long' : '')}>{tag.titleFlag}</span>
                    </span>
                })
            }
            {(full || !nutritionalTag) ? mappedFlags : '' }
        </div>
    )
}

ProductFlags.propTypes = {
    item: PropTypes.object,
    full: PropTypes.bool,
    nutritionalTag: PropTypes.bool,
    customTitle: PropTypes.string
};

export default ProductFlags;
